import React from 'react';

import { Field, FieldProps } from 'formik';

interface CustomInputProps {
	name: string;
	type?: string;
	placeholder?: string;
	label?: string;
	formikBag?: any;
	classNameWrap?: string;
	classNameInput?: string;
	component?: any;
	options?: any;
	stateSelected?: string | number;
	setStateSelected?: any;
	optionName1?: string;
	fieldValue?: string;
	setFieldValue?: any;
	optionName2?: string;
	innerIcon?: string | JSX.Element;
	removeSpace?: boolean;
	removeSpacesAll?: boolean;
	handleOnChange?: (e) => void;
}

const defaultInput: React.FC<FieldProps<any>> = (props: FieldProps) => {
	console.log(props, 'FieldPROPS');
	return <input value={props.field.value} onChange={props.field.onChange} onBlur={props.field.onBlur} />;
};

const CustomInput: React.FC<CustomInputProps> = ({
	type,
	name,
	label = '',
	placeholder = '',
	classNameWrap = '',
	classNameInput = '',
	component,
	formikBag,
	innerIcon,
	removeSpace = false,
	removeSpacesAll = false,
	handleOnChange = () => {},
}) => {
	const [nameFocused, setNameFocused] = React.useState(false);

	return (
		<div
			className={!classNameWrap.length ? (
				formikBag.errors[name] && formikBag.touched[name]
					? nameFocused
						? 'custom-input error focused '
						: 'custom-input error'
					: nameFocused
						? 'custom-input focused'
						: 'custom-input'
			) : (
				classNameWrap
			)}
			onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
				if (removeSpace) {
					formikBag.setFieldValue(name, event.target.value.trim());
				}
				if (removeSpacesAll) {
					formikBag.setFieldValue(name, event.target.value.replace(' ', ''));
				}
				handleOnChange(event);
			}}
			onFocus={(event) => setNameFocused(true)}
			/* onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
				setNameFocused(false);
				if (removeSpace) {
					formikBag.setFieldValue(name, event.target.value.trim());
				}
			}} */
		>
			{label && <label htmlFor={name}>{label}</label>}
			{classNameInput.length ? (
				<div className="is-relative">
					<Field
						type={type}
						component={component}
						name={name}
						placeholder={placeholder}
						id={name}
						autoComplete={name}
						className={classNameInput.length ? classNameInput : ''}
						// onBlur={onBlur}
					/>
					<div className="validation-message">{formikBag.errors[name] && formikBag.touched[name] ? formikBag.errors[name] : null}</div>
				</div>
			) : (
				<Field
					type={type}
					component={component}
					name={name}
					placeholder={placeholder}
					id={name}
					autoComplete={name}
					// onBlur={onBlur}
				/>
			)}
			<div className="custom-input__inner-icon">{innerIcon ?? innerIcon}</div>
			{!classNameInput.length && <div className="custom-input__error">{formikBag.errors[name] && formikBag.touched[name] ? formikBag.errors[name] : null}</div>}
			<div className="custom-input__placeholder-top">{placeholder}</div>
		</div>
	);
};

export default CustomInput;
